module.exports = __webpack_public_path__ + "static/media/OrvarOpen2026.4b20a394.jpg";